document.addEventListener('DOMContentLoaded', function(){
  var duration = 24,
      wrap     = document.getElementById('popup-wrap'),
      seconds  = wrap && wrap.querySelector('.seconds'),
      closeBtn = wrap && wrap.querySelector('.btn-close'),
      timer;

  if (!wrap || !seconds || !closeBtn) return;

  // Klasse .show hinzufügen, damit CSS es sichtbar macht
  wrap.classList.add('show');

  // Timer initialisieren
  seconds.textContent = duration;

  // Countdown
  timer = setInterval(function(){
    duration--;
    if (duration <= 0) {
      clearInterval(timer);
      wrap.classList.remove('show');
    } else {
      seconds.textContent = duration;
    }
  }, 1000);

  // Schließen-Button
  closeBtn.addEventListener('click', function(){
    clearInterval(timer);
    wrap.classList.remove('show');
  });
});

